// FileUpload.jsx
import React, { useRef } from "react";
import { Button } from "@mui/material";
import { uploadFile } from "api/DocumentAPI";
import { useNotificationStore } from 'store/NotificationStore'

const DocumentUpload = () => {
  const { addNotification } = useNotificationStore();
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (!files) return;

    Array.from(files).forEach((file) => {
      // Pass a progress callback that updates the upload progress in state
      uploadFile(
        file,
        () => {},
        (data) => {
          // Handle the success case (data contains the server response)
          console.log(`Upload successful for ${file.name}`, data);
          addNotification({
            message: `Plik ${file.name} zapisano pomyślnie!`,
            type: "success",
          });
        },
        (error) => {
          // Handle error during file upload
          console.error(`Error uploading ${file.name}`, error);
          addNotification({
            message: `Błąd podczas zapisywania pliku ${file.name}: ${error}`,
            type: "error",
          });
        }
      );
    });
  };

  return (
    <div>
      <Button
        className="nav-button" variant="outlined" color="inherit"
        onClick={() => {
          if (fileInputRef.current) fileInputRef.current.click();
        }}
      >
        Dodaj pliki
      </Button>
      <input
        type="file"
        multiple
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      {/* <Box mt={2}>
        {Object.keys(uploadProgress).map((fileName) => (
          <Box key={fileName} mb={2}>
            <Typography variant="body2">{fileName}</Typography>
            <LinearProgress
              variant="determinate"
              value={uploadProgress[fileName]}
            />
          </Box>
        ))}
      </Box> */}
    </div>
  );
};

export default DocumentUpload;
